import React, { Component } from 'react'
import { Container, Box, Text, Button, Field } from './code.style'
import { ErrorMessage, getIn } from 'formik'
import { getHiddenEmail } from '../../../../../../src/helpers/email.helper'
import { MuvicardService } from '../../../../../services/muvicard.service'

class Code extends Component {
	constructor(props) {
		super(props)
	}

	send = async step => {
		const { codigo } = this.props.values
		const { showLoading, hideLoading, onValidToken } = this.props
		try {
			showLoading()
			const response = await MuvicardService.ValidateTokenForPasswordReset(
				codigo
			)
			if (response.data && response.data.success) {
				onValidToken()
			}
		} catch (e) {
		} finally {
			hideLoading()
		}
	}

	componentDidMount() {
		if (window.location.search.match('&code=')) {
			let code = window.location.search.match('&code=').input.split('=')[2]
			if (code) {
				this.props.setFieldValue('codigo', code)
			}
		}
	}

	render() {
		const { handleChange, handleBlur, step } = this.props
		const { codigo } = this.props.values

		return (
			<Container>
				<Box>
					<Text>
						Por favor, verifique seu email e <b>acesse o link</b> enviado
						para <b>redefinição de senha.</b> Caso prefira, você pode{' '}
						<b>inserir o código manualmente</b>
					</Text>

					<Text className="nopadding">Inserir código manualmente</Text>

					<Field
						autoFocus
						type="text"
						placeholder="Código"
						name="codigo"
						onBlur={handleBlur}
						onChange={handleChange}
						id="codigo"
						value={codigo}
						autoComplete="off"
						className="nopadding safari-font-force"
					/>

					<ErrorMessage
						component="div"
						name="codigo"
						className="msg-error"
					/>

					<Button
						type="button"
						disabled={codigo.length === 0}
						onClick={() => this.send(step)}>
						Redefinir senha
					</Button>
				</Box>
			</Container>
		)
	}
}

export default Code
